import React, { useMemo } from 'react';
import './styles.scss';

export type SimpleSlideNavButtonSizes = 'small' | 'medium' | 'large' | number;
const sizes = {
    small: 30,
    medium: 40,
    large: 50,
};
interface SimpleSlideNavButtonProps {
    icon?: string;
    customClassName?: string;
    onClick?: () => void;
    size?: SimpleSlideNavButtonSizes;
    disabled?: boolean;
}

const SimpleSlideNavButton: React.FC<SimpleSlideNavButtonProps> = ({ icon, disabled, customClassName = '', onClick, size = 'medium' }) => {
    const sizeValue = useMemo(() => {
        if (typeof size === 'number') {
            return size;
        }
        return sizes[size];
    }, [size]);

    return (
        <button
            className={`simple-h-button ${customClassName}`}
            disabled={disabled}
            onClick={onClick}
            style={{ width: sizeValue, height: sizeValue }}
        >
            <span className="material-icons-outlined">{icon}</span>
        </button>
    );
};

const SimpleSlideNavButtonPrev: React.FC<SimpleSlideNavButtonProps> = (props) => {
    return <SimpleSlideNavButton icon="chevron_left" {...props} />;
};

const SimpleSlideNavButtonNext: React.FC<SimpleSlideNavButtonProps> = (props) => {
    return <SimpleSlideNavButton icon="chevron_right" {...props} />;
};

export { SimpleSlideNavButton, SimpleSlideNavButtonPrev, SimpleSlideNavButtonNext };
